// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import React from 'react';
import type { ReactNode } from 'react';
import './Badge.css';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  color: 'grey' | 'orange' | 'yellow' | 'green' | 'red' | 'blue' | 'teal' | 'neutral' | 'purple';
  size?: 'xs' | 'sm' | 'md' | 'lg';
  variant?: 'filled' | 'outlined';
  circular?: boolean;
  children: ReactNode;
}

export function Badge({
  color,
  size = 'md',
  variant = 'filled',
  circular = false,
  className = '',
  children,
  ...rest
}: BadgeProps) {
  const classes = [
    'fin-badge',
    `fin-badge--${color}`,
    `fin-badge--${size}`,
    `fin-badge--${variant}`,
    circular && 'fin-badge--circular',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <span className={classes} {...rest}>{children}</span>;
}
